import React from 'react';

import './classrooms.scss';

interface Props {
  children?: React.ReactNode;
}

export default function Classrooms({children}: Props) {
  return (
    <div className='classrooms teacher-classes'>
      {children && React.cloneElement(children as React.ReactElement, {})}
    </div>
  );
}
